import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import axios from 'axios';
import { render } from 'react-dom';
import { combineReducers } from 'redux';
import CookiePolicy from '@ma-js-common/cookie-policy';

import { initTouchEvent } from 'helpers/Device';
import { initAnalytics } from 'helpers/Ga';
import { initSentry } from 'helpers/Sentry';
import initGTM from 'helpers/GTM';
import watchForLoadedCss from 'helpers/IsLoaded';
import initNumeral from 'helpers/Numeral';
import initStore from 'Store';
import { initEstima } from 'helpers/Estima';
import Root from './Root';
import appSagas from './sagas';
import './sass/main.scss';
import { initDatadog } from 'helpers/Datadog';

(async function () {
    // Axios default options
    axios.defaults.withCredentials = true;

    await initEstima();
    initTouchEvent();
    initNumeral();
    watchForLoadedCss('.tooltip--estima-address-field');

    // Initialize Google Analytics with environment variables.
    initAnalytics(window.analyticsUser);

    initGTM(MA.Config.GTM_ID);
    initSentry();
    initDatadog();

    const cookiePolicy = new CookiePolicy();
    cookiePolicy.initialize();

    /**
     * Combine and return all app reducers.
     * @return {Object} Combined reducers
     */
    function getReducers() {
        // eslint-disable-line global-require
        const reducers = require('reducers/estima'); // eslint-disable-line global-require
        const formReducers = require('reducers/form/estimaForm').default; // eslint-disable-line global-require
        return combineReducers({
            ...reducers,
            form: formReducers,
        });
    }

    /**
     * Store of the app.
     * @type {ReduxStore}
     */
    const store = initStore(getReducers, appSagas);

    render(<Root store={store} />, document.getElementById('root'));

    if (module.hot) {
        module.hot.accept('./Root', () => {
            // eslint-disable-next-line global-require
            const RootContainer = require('./Root').default;
            render(<RootContainer store={store} />, document.getElementById('root'));
        });
    }
})();
